import axios, {AxiosInstance, AxiosRequestConfig, AxiosResponse} from 'axios'
import {ElLoading, ElNotification, ElMessage} from 'element-plus'
import store from "../store";
import actions from '../action';

const customConfig = {
    '/api/app/getPreSignedUrl': false
};
let loading

const formatValidationDetail = (detail = []) => {
    if (!Array.isArray(detail) || !detail.length) {
        return ''
    }
    return detail
        .map((item) => {
            if (!item) {
                return ''
            }
            const location = Array.isArray(item.loc) ? item.loc.join('.') : ''
            if (location && item.msg) {
                return `${location}: ${item.msg}`
            }
            return item.msg || ''
        })
        .filter(Boolean)
        .join('；')
}

const getErrorMessage = (data, fallback = '请求失败') => {
    if (!data) {
        return fallback
    }
    if (typeof data === 'string') {
        return data
    }
    if (data.msg) {
        return data.msg
    }
    if (data.message) {
        return data.message
    }
    if (Array.isArray(data.detail)) {
        return formatValidationDetail(data.detail) || fallback
    }
    if (typeof data.detail === 'string') {
        return data.detail
    }
    return fallback
}

// 创建 axios 实例
const request = axios.create({
    baseURL: '/fire',
    headers: {
        'Content-Type': 'application/json;charset=utf-8'
    },
    // API 请求的默认前缀
    timeout: 60000, // 请求超时时间,
})

// 异常拦截处理器
const errorHandler = (error) => {
    loading && loading.close()
    const status = error?.response?.status
    const errorData = error?.response?.data
    if (status == 401) {
        // 退出登录
        actions.setGlobalState({noToken: true, activePath: '/'});
    }
    ElMessage({
        type: 'error',
        message: getErrorMessage(errorData, error.message || '请求失败'),
        grouping: true,
        repeatNum: 1
    })
    return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
    const isLoading = customConfig[config.url] || false;
    // 如果 isLoading 为 true，则显示加载动画
    if (isLoading) {
        loading = ElLoading.service({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.4)'
        })
    }
    const token = sessionStorage.getItem("token");
    // 如果 token 存在
    // 让每个请求携带自定义 token 请根据实际情况自行修改
    if (token) {
        config.headers['Authorization'] = JSON.parse(token)
    }else{
        config.headers['Authorization'] =''
    }
    config.headers['Mark'] = '122'
    return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
    let marketid = ''
    if (response.config.url == '/api/uap2.0/login' || response.config.url == '/api/uap2.0/exchangeForToken') {
        marketid = response.headers.marketid ? response.headers.marketid : ''
        sessionStorage.setItem('marketid', marketid)
    }
    const {data} = response
    // const { getStatus, logout } = useLayoutStore()
    loading && loading.close()
    // 二进制数据则直接返回
    if (response.request.responseType === 'blob' || response.request.responseType === 'arraybuffer') {
        return response
    }
    if (data.code !== 200) {
        if (data.code === 401) {
            // 退出登录
            actions.setGlobalState({noToken: true, activePath: '/'});
        }
        ElMessage({
            type: 'error',
            message: getErrorMessage(data),
            grouping: true,
            repeatNum: 1
        })
        return Promise.reject(data.response)
    }
    return response.data
}, errorHandler)


export default request
